import { InjectorService } from '@tencent/ioc';
import { StateManager } from '../../services/store/state-manager.js';
import { WorkbenchConfigurationState } from '../../services/settings/auto-sync-settings.js';

const handlerStatusColor = {
    success: '#2e7d32',
    stop: '#bf360c',
    error: '#d32f2f',
    skip: '#757575',
};
function isIActionPointRunner(runner) {
    return !!(typeof runner === 'function' && runner.point
        && runner.context && runner.hasNext
        && runner.stop);
}
function setActionPointEvent(runner, event) {
    if (isIActionPointRunner(runner)) {
        runner.context.event = event;
    }
}
/**
 * @internal
 */
class ActionPointRunner extends Function {
    constructor(middlewares, point, metadata = {}) {
        super();
        this.middlewares = middlewares;
        /**
         * 是否开启 debug 模式
         */
        this.debug = false;
        /**
         * 中间件队列运行信息
         */
        this.debugInfo = [];
        this.runningHandlerInfo = {};
        this.hasCalled = false;
        this.hasRaw = false;
        const closure = (...args) => closure.run(...args);
        closure.middlewares = middlewares;
        closure.context = {
            metadata,
        };
        closure.point = point !== null && point !== void 0 ? point : {
            name: '', from: '', trigger: '', path: [],
        };
        closure.hasRaw = false;
        return Object.setPrototypeOf(closure, new.target.prototype);
    }
    getNext(skip = false) {
        let next = () => { };
        next.hasCalled = this.hasCalled;
        if (this.hasNext()) {
            this.index += 1;
            const handler = this.middlewares[this.index];
            next = () => {
                next.hasCalled = true;
                return handler(this, skip);
            };
            next.hasCalled = this.hasCalled;
        }
        this.hasCalled = false;
        return next;
    }
    merge(handlers) {
        const runner = new ActionPointRunner(handlers.concat(this.middlewares), this.point, this.context.metadata);
        runner.debug = this.debug;
        runner.hasRaw = this.hasRaw;
        return runner;
    }
    setOnCall(handler) {
        this.onCall = handler;
    }
    setContext(context) {
        Object.assign(this.context, context);
    }
    hasNext() {
        return this.index < this.middlewares.length - 1;
    }
    get next() {
        const handler = this.getNext();
        return handler;
    }
    get skip() {
        const handler = this.getNext(true);
        return handler;
    }
    get data() {
        return this.result;
    }
    run(...args) {
        this.rawArguments = args;
        this.index = -1;
        this.debugInfo = [];
        this.runningHandlerInfo = {};
        if (this.onCall) {
            this.onCall();
        }
        this.next();
        if (this.debug || InjectorService.get(StateManager).getValue(WorkbenchConfigurationState.DebugMode)) {
            this.printDebugInfo();
        }
        const { data } = this;
        this.cleanResult();
        return data;
    }
    cleanResult() {
        this.result = undefined;
    }
    traceStart(name, type) {
        const now = Date.now();
        this.runningHandlerInfo[name] = {
            start: now,
            type,
        };
    }
    traceEnd(name, result) {
        const now = Date.now();
        const info = this.runningHandlerInfo[name];
        if (info) {
            this.debugInfo.push([name, info.type, result, now - info.start]);
        }
    }
    storeData(value) {
        this.result = value;
    }
    stop() {
        this.hasCalled = true;
    }
    getArguments() {
        return this.rawArguments;
    }
    printDebugInfo() {
        const labelStyle = [
            'font-family: Consolas, monospace',
            'display: inline-block',
            'padding: 2px',
            'border: 1px solid #ffa000',
            'background-color: #ffd14933',
        ];
        // eslint-disable-next-line no-console
        console.group(`%c@${this.point.from}(${this.point.name}, ${this.point.trigger})`, labelStyle.join(';'));
        this.debugInfo.forEach(([name, type, result, time]) => {
            // eslint-disable-next-line no-console
            console.log(`${`%c${result}%c`.padEnd(14, ' ')} [%c${type}%c]: ${time}ms --> ${name}`, `color: white; background-color: ${handlerStatusColor[result]};`, 'color: unset', `color: ${type === 'controller' ? '#66bb6a' : '#42a5f5'}`, 'color: unset');
        });
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
}

export { ActionPointRunner, isIActionPointRunner, setActionPointEvent };
//# sourceMappingURL=action-point-runner.js.map
